import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase/firebase';
import { doc, getDoc, collection, getDocs, deleteDoc } from 'firebase/firestore';
import TransactionForm from '../components/TransactionForm';
import CategoryManager from '../components/CategoryManager';
import '../styles/CardDetailsPage.css'; // Ensure CSS is properly linked

export default function CardDetailsPage() {
    const { cardId } = useParams();
    const [card, setCard] = useState(null);
    const [transactions, setTransactions] = useState([]);

    useEffect(() => {
        const fetchCardDetails = async () => {
            const cardRef = doc(db, "cards", cardId);
            const cardSnap = await getDoc(cardRef);
            if (cardSnap.exists()) {
                const cardData = { id: cardSnap.id, ...cardSnap.data() };

                const transactionsSnapshot = await getDocs(collection(db, "cards", cardId, "transactions"));
                const fetchedTransactions = transactionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setTransactions(fetchedTransactions);

                cardData.categories = cardData.categories.map(category => {
                    const totalSpent = fetchedTransactions.filter(t => t.category === category.name).reduce((acc, curr) => acc + curr.amount, 0);
                    return { ...category, remaining: category.limit - totalSpent };
                });
                setCard(cardData);
            }
        };

        fetchCardDetails();
    }, [cardId]);

    // Function to delete a transaction
    const handleDeleteTransaction = async (transactionId) => {
        await deleteDoc(doc(db, "cards", cardId, "transactions", transactionId));
        setTransactions(transactions.filter(transaction => transaction.id !== transactionId));
    };

    return (
        <div className="container mt-5">
            {card ? (
                <div>
                    <h1 className="text-center mb-3">{card.name} - Category Limits</h1>
                    <div className="card mb-3">
                        <div className="card-body">
                            {card.categories.map((cat, index) => (
                                <div key={index} className="category-entry">
                                    <span className="category-name"><b>{cat.name}</b>:</span>
                                    <span className="category-limit">{cat.remaining.toFixed(2)} / {cat.limit.toFixed(2)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <CategoryManager cardId={cardId} initialCategories={card.categories} />
                    <TransactionForm cardId={cardId} categories={card.categories} />
                    <div className="transactions-list">
                        <h2>Transactions</h2>
                        {transactions.map((txn) => (
                            <div key={txn.id} className="transaction-entry">
                                <p><b>Amount:</b> ₹{txn.amount}</p>
                                <p><b>Category:</b> {txn.category}</p>
                                <p><b>Note:</b> {txn.note}</p>
                                <p><b>Date:</b> {txn.timestamp.toDate().toLocaleString()}</p>
                                <button onClick={() => handleDeleteTransaction(txn.id)} className="btn btn-danger">Delete</button>
                                {/* Add Edit Button functionality if needed */}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <p>Loading card details...</p>
            )}
        </div>
    );
}
